import {EValidationTestType} from "../../../utils/validationConfigs";

export const formConfig = {
    register: {
        ahvNumber: {
            model: "register",
            name: "ahvNumber",
            standardMessage: undefined,
            validationTests: [
                EValidationTestType.hasValue,
                EValidationTestType.isSsn
            ],
            visible: true,
            showSuccess: true,
        },
    },
};
